import axios from 'axios';
import { environment } from './environment';

const axiosClient = axios.create({
  baseURL: environment.baseUrl,
})

export { axiosClient };